export interface SleepInput {
  bedtime: string;
  wakeTime: string;
  quality: number;
}

export interface SleepValidation {
  ok: boolean;
  error: 'invalid_order' | 'too_long' | 'too_short' | null;
  durationMinutes: number;
  circadianDate: string;
}

export const MIN_DURATION_MIN = 30;
export const MAX_DURATION_MIN = 24 * 60;
export const QUALITY_MIN = 1;
export const QUALITY_MAX = 5;